import React, { useState, useEffect } from 'react';

// context
import ModeContext from '../context/ModeContext';

import basinJSON from '../assets/json/basin_with_bound.json';
import provinceJSON from '../assets/json/province_with_bound.json';

function ModeProvider({ children }) {
  // version
  const version = '20201027'; // ทุกครั้งที่มีการเพิ่ม parameter ใน mode ให้เปลี่ยนวันที่เป็นวันที่ปรับ เพื่อให้ localStorage อัพเดต

  // check storage
  const modeItem = localStorage.getItem('mode');
  const modeLocal = JSON.parse(modeItem);

  // set expire
  if (modeItem !== null && (modeLocal.mode_expire === undefined || modeLocal.modeLocal.mode_expire !== version)) {
    localStorage.removeItem('mode');
  }

  const [currentMode, setCurrentMode] = useState(modeItem !== null ? modeLocal.currentMode : 'province');

  const [
    selectList, setSelectList,
  ] = useState(modeItem !== null ? modeLocal.selectList : provinceJSON);

  const [
    currentSelectList, setCurrentSelectList,
  ] = useState(modeItem !== null ? modeLocal.currentSelectList : 0); // 0=ทุกลุ่มน้ำ,ทั่วประเทศ

  const [currentTextSelectList, setTextCurrentSelectList] = useState(modeItem !== null ? modeLocal.currentTextSelectList : 'ทั่วประเทศ');

  const currentAreaParam = {
    id: 0,
    code: '0',
    name: '',
    location: [13.736717, 100.523186],
    zoom: 6,
    top_left: [5.69138418215, 97.3758964376],
    bottom_right: [20.4178496363, 105.589038527],
  };

  const [
    currentArea, setCurrentArea,
  ] = useState(modeItem !== null ? modeLocal.currentArea : currentAreaParam);

  const [currentModeContext, setCurrentModeContext] = useState({
    currentMode: '',
    selectList: null,
    currentSelectList: 0,
    currentTextSelectList: '',
    currentArea,
    handleModeClick: () => {},
    handleSelectListChange: () => {},
  });

  // order asc
  selectList.sort((a, b) => a.name.localeCompare(b.name, 'th'));

  const handleModeClick = (e) => {

    setCurrentMode(e.target.value);

    if (e.target.value === 'basin') {
      setSelectList(basinJSON);
      setCurrentSelectList(0);
      setTextCurrentSelectList('ทุกลุ่มน้ำ');
    } else {
      setSelectList(provinceJSON);
      setCurrentSelectList(0);
      setTextCurrentSelectList('ทั่วประเทศ');
    }

    setCurrentArea(currentAreaParam);
  };

  const handleSelectListChange = (e) => {
    setCurrentSelectList(e.target.value);
    const areaFilter = selectList.filter((d) => d.code === e.target.value);

    if (areaFilter.length > 0) {
      setCurrentArea({ ...areaFilter[0] });
    } else {
      setCurrentArea(currentAreaParam);
    }
  };

  const handleSelectListClick = (value) => {
    setCurrentSelectList(value);
    const areaFilter = selectList.filter((d) => d.code === value);

    if (areaFilter.length > 0) {
      setCurrentArea({ ...areaFilter[0] });
    } else {
      setCurrentArea(currentAreaParam);
    }
  };

  useEffect(() => {
    setCurrentModeContext({
      currentMode,
      selectList,
      currentSelectList,
      currentTextSelectList,
      currentArea,
      handleModeClick,
      handleSelectListChange,
      handleSelectListClick,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMode, selectList, currentSelectList, currentTextSelectList, currentArea]);

  // local storage
  localStorage.setItem('mode', JSON.stringify({
    currentMode, selectList, currentSelectList, currentTextSelectList, currentArea, mode_version: version,
  }));

  return (
    <ModeContext.Provider
      value={currentModeContext}
    >
      {children}
    </ModeContext.Provider>
  );
}

export default ModeProvider;
